import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_DASHBOARD_INFO
} from "./actionTypes.js";

import { dashboardInfoApi } from "./dashboardApi.js";
import { getDashboardInfoFail, getDashboardInfoSuccess } from "./actions.js";

function* fetchDashboardInfo() {
    try {
        const response = yield call(dashboardInfoApi)
        yield put(getDashboardInfoSuccess(response))
    } catch (error) {
        yield put(getDashboardInfoFail(error))
    }
}



function* DashboardSaga() {
    yield takeEvery(GET_DASHBOARD_INFO, fetchDashboardInfo)
}

export default DashboardSaga
